export const populateNameFields = (searchValue?: string | null) => {
  const result = {
    firstName: '',
    lastName: '',
  };

  if (!searchValue) {
    return result;
  }

  const trimmedSearch = searchValue.trim();

  if (trimmedSearch.includes(',')) {
    return result;
  }

  const words = trimmedSearch.split(/\s+/).filter((word) => word.length > 0);

  if (words.length === 1) {
    result.lastName = words[0];
    return result;
  }

  if (words.length > 1) {
    result.firstName = words[0];
    result.lastName = words.slice(1).join(' ');
  }

  return result;
};
